import { createContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { demo } from "../constants/payloads";
import { deleteSuccess, fieldError, todoAdded, todoCompleted, todoInComplete, todoUpdated } from "../constants/toasts";

export const TodoContext = createContext({});

export const TodoContextProvider = ({ children }) => {
  const navigate =  useNavigate();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  var [myTodos, setMyTodos] = useState([])
  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => setOpenDelete(true);
  const handleCloseDelete = () => setOpenDelete(false);
  const [todoItem, setTodoItem] = useState(null);

  const getTodos = () => {
    if (window.localStorage.getItem("todos")) {
      setMyTodos(JSON.parse(window.localStorage.getItem("todos")));
    } else {
      window.localStorage.setItem("todos", JSON.stringify(demo));
      setMyTodos(demo);
    }
  };

  const updateTodo = (id, title, content, done, due) => {

    if (!title || !content || !due) {
      fieldError();
      return
    }

    let updatedTodos = [];

    myTodos.forEach(item => {
      if (item.id === id) {
        item.done = done;
        item.title = title;
        item.content = content;
        item.due = due;
      }
      updatedTodos.push(item);
    })

    myTodos = updatedTodos;
    window.localStorage.setItem("todos", JSON.stringify(myTodos));
    returnTodoItem(id);
    todoUpdated();
    handleClose();
  };

  const deleteTodo = (todo) => {
    myTodos = myTodos.filter(myTodos => myTodos.id !== todo.id);
    window.localStorage.setItem("todos", JSON.stringify(myTodos));
    deleteSuccess();
    handleCloseDelete();
    return navigate("/")
  };

  const addTodo = (title, content, due) => {
    const id = myTodos.length;
    if (!title || !content || !due) {
      fieldError();
      return
    }
    myTodos.push({id, title, content, done: false, due})
    window.localStorage.setItem("todos", JSON.stringify(myTodos));
    todoAdded();
    getTodos();
    handleClose();
  };

  const markTodo = (todo, done) => {
    // Reduce Function
    let updatedTodos = [];
    myTodos.forEach(item => {
      if (item.id === todo.id) {
        item.done = done
      }
      updatedTodos.push(item);
    })
    myTodos = updatedTodos;
    window.localStorage.setItem("todos", JSON.stringify(myTodos));
    getTodos();
    done ? todoCompleted() : todoInComplete();
  };

  const returnTodoItem = (id) => {
    getTodos();
    setTodoItem(myTodos?.filter((todo) => todo.id === parseInt(id))[0]);
  }

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const value = {
    open,
    myTodos,
    todoItem,
    openDelete,
    addTodo,
    getTodos,
    markTodo,
    deleteTodo,
    handleOpen,
    updateTodo,
    handleClose,
    setTodoItem,
    returnTodoItem,
    handleOpenDelete,
    handleCloseDelete,
  };

  return (
    <div>
      <TodoContext.Provider value={value}>{children}</TodoContext.Provider>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};
